import(/* webpackMode: "eager" */ "__barrel_optimize__?names=ConfigProvider!=!/app/node_modules/antd/es/index.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/globals.scss");
import(/* webpackMode: "eager" */ "/app/src/app/components/providers/proxyProvider/index.jsx");
import(/* webpackMode: "eager" */ "/app/src/app/components/providers/TranslationsProvider.jsx");
import(/* webpackMode: "eager" */ "/app/src/app/context/ChatContext.jsx");
import(/* webpackMode: "eager" */ "/app/src/app/context/UserContext.jsx")